import { Container } from 'react-bootstrap';
import { Link } from '@/compat/react-router-dom';
import { FaBus, FaCarRear } from 'react-icons/fa6';
import { BsArrowUpRight } from 'react-icons/bs';
import { getMediaUrl, toPathSegment } from '@/utils/imageUrl';

const PartnerAffiliateHeader = ({
  partnerName,
  partnerSlug = '',
  currentService = '',
  partnerWebsiteUrl = '',
  partnerLogoUrl = '',
  partnerColor = '',
}) => {
  const logoSrc = partnerLogoUrl ? (getMediaUrl(partnerLogoUrl, partnerLogoUrl) || partnerLogoUrl) : '';
  const normalizedWebsite = String(partnerWebsiteUrl || '').trim();
  const safeWebsite = normalizedWebsite
    ? (normalizedWebsite.match(/^https?:\/\//i) ? normalizedWebsite : `https://${normalizedWebsite}`)
    : '';
  const accentColor = String(partnerColor || '').trim() || '#0d6efd';
  const safePartnerSlug = toPathSegment(partnerSlug, '');
  const slugSegment = safePartnerSlug ? encodeURIComponent(safePartnerSlug) : '';
  const serviceItems = [
    {
      key: 'excursions',
      label: 'Excursions',
      to: `/partner/${slugSegment}/excursions`,
      Icon: FaBus,
    },
    {
      key: 'car-rental',
      label: 'Car Rental',
      to: `/partner/${slugSegment}/car-rental`,
      Icon: FaCarRear,
    },
  ];

  return (
    <header className="partner-affiliate-header border-bottom">
      <Container className="partner-affiliate-header__row py-3">
        <div className="partner-affiliate-left">
          {safeWebsite ? (
            <a
              href={safeWebsite}
              target="_blank"
              rel="noreferrer noopener"
              className="partner-affiliate-logo-panel partner-affiliate-utility partner-affiliate-logo-panel--partner-link text-decoration-none"
              style={{ '--partner-accent': accentColor }}
              aria-label={`${partnerName} — open website in a new tab`}
            >
              {logoSrc ? (
                <img
                  src={logoSrc}
                  alt=""
                  className="partner-affiliate-utility__logo"
                  aria-hidden="true"
                />
              ) : (
                <span className="partner-affiliate-utility__name">{partnerName}</span>
              )}
              <span className="partner-affiliate-utility__cta-pill" aria-hidden="true">
                <BsArrowUpRight size={15} />
                Back to website
              </span>
            </a>
          ) : (
            <div className="partner-affiliate-logo-panel partner-affiliate-utility">
              {logoSrc ? (
                <img
                  src={logoSrc}
                  alt={`${partnerName} logo`}
                  className="partner-affiliate-utility__logo"
                />
              ) : (
                <span className="partner-affiliate-utility__name">{partnerName}</span>
              )}
            </div>
          )}
        </div>

        <div className="partner-affiliate-center">
          {slugSegment ? (
            <nav className="d-flex align-items-center gap-2 flex-wrap partner-affiliate-services-nav justify-content-center">
              {serviceItems.map(({ key, label, to, Icon }) => {
                const isActive = String(currentService || '').trim() === key;
                return (
                  <Link
                    key={key}
                    to={to}
                    className={`btn btn-sm partner-affiliate-cta ${isActive ? 'partner-affiliate-cta--primary' : 'partner-affiliate-cta--secondary'}`}
                    style={{ '--partner-accent': accentColor }}
                    aria-current={isActive ? 'page' : undefined}
                  >
                    <Icon size={15} />
                    {label}
                  </Link>
                );
              })}
            </nav>
          ) : null}
        </div>

      </Container>
    </header>
  );
};

export default PartnerAffiliateHeader;
